export default {
    data() {
        return {
            idNumber: "",
            canSearch: false,
            certificate: null,
            expired: false
        }
    },
    mounted: function () {
        let key = this.$route.query.key;
        if (key != null && key != undefined && (key.length == 15 || key.length == 18)) {
            this.idNumber = key;
            this.search();
        }
    },
    methods: {
        onIptChange: function (e) {
            this.canSearch = this.idNumber.length == 15 || this.idNumber.length == 18;
        },
        formateDate: function (date) {
            if (date == null || date.length < 10) return date;
            return date.substring(0, 10);
        },
        search: function () {
            if (this.idNumber.length != 15 && this.idNumber.length != 18) {
                this.$message.warning("身份证号有误");
                return;
            }
            this.$post({
                url: "certificate_record/query",
                params: {
                    idNumber: this.idNumber
                }
            }, true).then(res => {
                this.certificate = res;
                var date = new Date(res.createDate);
                date.setFullYear(date.getFullYear() + 1);
                this.expired = date.getTime() < new Date().getTime()

                // 后续版本升级 动态验证时效性
                // var time = "2019年12月12日（你的时间）";
                // time = time.substring(0, time.indexOf(' '));
                // time = time.replace(/([年月])/g, '-');
                // time = time.replace(/日/g, '');
                // new Date(time) // 最后你需要转化的时间
            }).catch(err => {
                this.certificate = null;
            });
        }
    }
}